export enum CountryParametersDesc {
    HelpCenterEmail = "SECM_TEMPLATE_HELP_CENTER_EMAIL",
    HelpCenterPhoneNumber = "SECM_TEMPLATE_HELP_CENTER_PHONE_NUMBER",
    PrivacyPolicyLink = "SECM_TEMPLATE_PRIVACY_POLICES_LINK",
    TermsAndConditionsLink = "SECM_TEMPLATE_PRIVACY_POLICES_LINK",
    LearningCenterLink = "SECM_LEARNING_CENTER_LINK",
    LearningHubLink = "SECM_LEARNING_HUB_LINK",
}
